import { ArrowRight } from 'lucide-react';

export default function ExquraAbout({ fields = {} }) {
  const {
    headline = "About Exqura",
    body = "At Exqura, we believe that golf is more than a game — it's an experience. We are committed to promoting sustainable golf tourism by partnering with eco-conscious courses and resorts. Every booking you make supports green initiatives and local communities across our destinations, ensuring that the fairways you love today will be there for generations to come.",
    image = "https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?w=1920&q=80",
    ctaLabel = "Find Out More",
    ctaHref = "/AboutUs",
  } = fields;

  return (
    <section className="bg-white py-5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="bg-[#F4B41A] rounded-3xl py-10 px-6 sm:px-10 lg:px-14">
        <div className="flex flex-col md:flex-row items-center gap-10 md:gap-16">
          {/* Circular Image */}
          <div className="shrink-0 w-64 h-64 sm:w-80 sm:h-80  overflow-hidden rounded-3xl shadow-2xl">
            <img
              src={image}
              alt="Golf ball near hole"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Text Content */}
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-[#0B2421] font-bold text-3xl sm:text-4xl mb-4">{headline}</h2>
            <p className="text-[#0B2421]/80 text-base sm:text-lg leading-relaxed mb-6 whitespace-pre-line">
              {body}
            </p>
            <a
              href={ctaHref}
              className="inline-flex items-center gap-2 text-[#0B2421] font-bold text-sm hover:gap-3 transition-all"
            >
              {ctaLabel} <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
      </div>
    </section>
  );
}
